
<div class="performance-evalution-container">
  <div class="header">
    <div class="sec-title">
      <span class="hdr-ic"><i class="material-icons">workspace_premium</i></span>
      <div class="sec-title-txt">
        <h2>Performance Evaluation</h2>
        <span class="sec-sub">Quarterly contractor ratings</span>
      </div>
    </div>
      <div class="performance-evalution-details-search">
          <div class="search-child">
            <emerald-input
              [label]="'Search'"
              [trailingIcon]="'search'"
              (keyup)="searchPerformanceRecord($event)"
              [value]="filterValue">
              <emerald-icon
                *ngIf="filterValue?.length && filterValue.length > 0"
                [icon]="'close'"
                (click)="clearInput()">
              </emerald-icon>
            </emerald-input>
          </div>
          <div class="select-container">
            <emerald-dropdown
                 [id]="'multi_select'"
              [label]="'Quarters'"
              [outlined]="true"
              [multiSelect]="true"
              [options]="quarterOptions"
              (onChange)="onQuarterSelect($event)"
            ></emerald-dropdown>
               <emerald-menu
            [opened]="opened"
            [position]="'bottom_end'"
            [targetElement]="navTemplate"
            [menuTemplate]="menuTemplate"
            (openChange)="opened = $event"
          ></emerald-menu>
          <ng-template #navTemplate>
            <emerald-button
              [label]="'Filter'"
              [size]="'Small'"
              [type]="'Secondary'"
              [icon]="'filter_list'"
              [iconPosition]="'Left'"
              (onClick)="this.opened = !this.opened"
            ></emerald-button>
          </ng-template>
          <ng-template #menuTemplate>
            <app-performance-filter
              [performanceData]="data"
              (resetFilter)="resetFilter($any($event))"
              (applyFilter)="applyFilter($any($event))"
              (applyFilterCriteria)="onFilterCriteriaReceived($any($event))"
            ></app-performance-filter>
          </ng-template>
          </div>

            <emerald-button
              [label]="'Download'"
              [type]="'Secondary'"
              [icon]="'download'"
              [disabled]="selectedRows.length === 0"
              (onClick)="download()"
            >
            </emerald-button>
      </div>
  </div>

  <ng-container *ngIf="displayData?.length; else noDataTemplate">
    <emerald-datatable
      [columnDefs]="columnDefs"
      [rowData]="displayData"
      [paginationParams]="paginationParams"
      [allowResizeColumns]="true"
      (onRowSelect)="onRowSelected($event)"
      [customCellTemplate]="{
        select: customSelectColumn,
        employeeName: customNameColumn,
        quarterYear: customQuarterYearColumn
      }"
    ></emerald-datatable>
  </ng-container>

  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container *ngIf="isDataLoaded">
          <h2 class="empty-state-title">{{ errorMsg }}</h2>
        </ng-container>
        <img
          [src]="imageSrc"
          alt="No records illustration"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>

  <ng-template #customSelectColumn let-level="level" let-eachRow="eachRow">
    <emerald-checkbox
      [title]="'Select Item'"
      [checked]="eachRow?.selected || false"
      [forceRefresh]="true"
      (onChange)="onCheckboxChange(eachRow, $event)">
    </emerald-checkbox>
  </ng-template>

  <ng-template #customNameColumn let-level="level" let-eachRow="eachRow">
    <div class="member">
      <div class="name">
     <a class="job-title" (click)="navigateToContractorProfile(eachRow?.employeeId)">{{ eachRow?.employeeName
        }}</a>
      </div>
    <div class="title">{{ eachRow?.jobTitle }}</div> 
    </div>
  </ng-template>

  <ng-template #customQuarterYearColumn let-level="level" let-eachRow="eachRow">
    <div>{{ eachRow?.quarter }} {{ eachRow?.year }}</div>
  </ng-template>

  <app-modal-wrapper *ngIf="showContractorProfile" [showModal]="showContractorProfile">
    <app-vendor-contractor-profile
      [contractorId]="contractorId"
      (close)="showContractorProfile = false"
    ></app-vendor-contractor-profile>
  </app-modal-wrapper>
</div>
